<template>
  <BaseModal :model-value="Boolean(aiQuotaNotice)" :title="t('common.aiAccess.quotaTitle')" @update:model-value="close">
    <div class="space-y-4 text-sm text-gray-700 dark:text-gray-200">
      <p>{{ t('common.aiAccess.empty') }}</p>
      <p>{{ resetText }}</p>
      <p>{{ recoveryText }}</p>
    </div>
    <template #footer>
      <div class="flex flex-col gap-3 sm:flex-row sm:justify-end">
        <BaseButton variant="outline" @click="close">{{ t('common.close') }}</BaseButton>
        <BaseButton v-if="canConfigure" @click="configure">{{ t('common.aiAccess.configureKey') }}</BaseButton>
      </div>
    </template>
  </BaseModal>
</template>
<script setup lang="ts">
import { watch } from 'vue'
import { useI18n } from 'vue-i18n'
import BaseModal from '@/components/base/BaseModal.vue'
import BaseButton from '@/components/base/BaseButton.vue'
import { aiQuotaNotice } from '@/domain/ai-quota-notice'
import { aiQuotaApi } from '@/services/api/ai-quota-api'
import { useAiQuotaRecovery } from '@/composables/useAiQuotaRecovery'
import { useAuthStore } from '@/stores/auth'
const { t } = useI18n()
const auth = useAuthStore()
const { canConfigure, resetText, recoveryText, configureKey } = useAiQuotaRecovery(() => aiQuotaNotice.value?.nextResetAt)
function close() { aiQuotaNotice.value = null }
function configure() { close(); void configureKey() }
watch(() => auth.token, close)
watch(aiQuotaNotice, async notice => {
  if (!notice || notice.nextResetAt) return
  try {
    const summary = await aiQuotaApi.getSummary()
    if (aiQuotaNotice.value === notice && summary.nextResetAt) aiQuotaNotice.value = { nextResetAt: summary.nextResetAt }
  } catch { /* Keep the truthful unknown-reset message when quota lookup fails. */ }
})
</script>
